/* eslint-disable */
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import { assetImages } from "constants";

/*------ import url and method ------*/
import * as url from "helper/UrlHelper";
import { getData } from "utils/Gateway";

import {
  eventMemberRoleSlug,
  eventSpeakerRoleSlug,
  eventslug,
  placeholderCount,
} from "Config/Config";

import InitialMeetingModal from "Components/Common/Modals/MeetingModals/InitialMeetingModal";
import SetupMeetingModal from "Components/Common/Modals/MeetingModals/SetupMeetingModal";
import ScheduleConfirmModal from "Components/Common/Modals/MeetingModals/ScheduleConfirmModal";
import MeetingDetailsModal from "Components/Common/Modals/MeetingModals/MeetingDetailsModal";
import ConnetModal from "Components/Common/Modals/ConnetModal";
import ViewConnectModal from "Components/Common/Modals/ViewConnectModal";
import UserPlaceHolder from "../PlaceHolder/UserPlaceHolder";
import UserCard from "../Card/UserCard";
import UserListFilterPopup from "../Popup/UserListFilterPopup";

const UserList = ({ eventId, showTitle, componentName }) => {
  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const limitResult = 30;

  const [isLoading, setIsLoading] = useState(false);
  const [memberList, setMemberList] = useState([]);
  const [pageNo, setPageNo] = useState(1);
  const [hideLoadMore, setHideLoadMore] = useState(false);

  const [filterName, setfilterName] = useState("");
  const [filterLocation, setfilterLocation] = useState("");
  const [filterCountry, setfilterCountry] = useState("");
  const [filterZipcode, setfilterZipcode] = useState("");
  const [filterCompany, setfilterCompany] = useState("");
  const [filterMyConnect, setfilterMyConnect] = useState(false);

  const [personId, setPersonId] = useState("");
  const [personName, setPersonName] = useState("");

  const [comments, setcomments] = useState("");
  const [meetingReason, setmeetingReason] = useState("");

  const [selectedMeetingDate, setSelectedMeetingDate] = useState("");
  const [selectedTimeSlot, setSelectedTimeSlot] = useState("");

  //function for get event details
  const getEventMembers = async (start, limit) => {
    try {
      setIsLoading(true);

      let requestUrl =
        url.API_BASE_URL +
        url.API_GUEST_ALL_EVENT_MEMBER +
        `?event=${eventId}&start=${start}&limit=${limit}`;

      if (componentName === "networks") {
        requestUrl += `&roleslug=${eventMemberRoleSlug}`;
      } else if (componentName === "speakers") {
        requestUrl += `&roleslug=${eventSpeakerRoleSlug}`;
      } else {
      }

      //check user logged in or not
      if (userInfo) {
        requestUrl += `&loggedinuserid=${userInfo?._id}`;
      }

      //name
      if (filterName && filterName != "") {
        requestUrl += `&filtermembername=${filterName}`;
      }

      //city/location
      if (filterLocation && filterLocation != "") {
        requestUrl += `&filtermembercity=${filterLocation}`;
      }

      //country
      if (filterCountry && filterCountry != "") {
        requestUrl += `&filtermembercountry=${filterCountry}`;
      }

      //zipcode
      if (filterZipcode && filterZipcode != "") {
        requestUrl += `&filtermemberzipcode=${filterZipcode}`;
      }

      //company
      if (filterCompany && filterCompany != "") {
        requestUrl += `&filtermembercompany=${filterCompany}`;
      }

      //my connect
      if (filterMyConnect) {
        requestUrl += `&filtermyconnect=${filterMyConnect}`;
      }

      console.log("url of event members ------>", requestUrl);

      const response = await getData(requestUrl);

      setIsLoading(false);

      console.log("response of event members ------>", response);

      if (response.status) {
        if (response.data.length > 0) {
          if (start === 1) {
            setMemberList(response.data);
          } else {
            setMemberList([...memberList, ...response.data]);
          }
        }

        if (response.data.length === limitResult) {
          setHideLoadMore(false);
        } else {
          setHideLoadMore(true);
        }
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //click load more button
  const onNextPage = () => {
    setPageNo(pageNo + 1);
  };

  //meeting function for select person
  const onSelectMeeting = (personData) => {
    setPersonId(personData?.user?._id);
    setPersonName(personData.name);
  };

  //connect request on select connect
  const onSelectConnect = (personData) => {
    setPersonId(personData?.user?._id);
    setPersonName(personData.name);
  };

  //view contact
  const onViewConnect = (personData) => {
    setPersonId(personData?.user?._id);
  };

  const resetFilter = () => {
    setfilterName("");
    setfilterLocation("");
    setfilterCountry("");
    setfilterZipcode("");
    setfilterCompany("");
    setfilterName("");
    setfilterMyConnect(false);
  };

  const refreshHandler = () => {
    resetFilter();
    setPageNo(1);
    getEventMembers(1, limitResult);
  };

  //reset person
  const resetPersonInfo = () => {
    setPersonName("");
    setPersonId(null);
  };

  //resetScheduleMeet
  const resetScheduleMeet = () => {
    resetPersonInfo();
    setmeetingReason("");
    setcomments("");
    setSelectedMeetingDate("");
    setSelectedTimeSlot("");
  };

  useEffect(() => {
    if (
      pageNo ||
      filterName != "" ||
      filterLocation != "" ||
      filterCountry != "" ||
      filterZipcode != "" ||
      filterCompany != "" ||
      filterMyConnect
    ) {
      getEventMembers(pageNo, limitResult);
    } else {
      getEventMembers(1, limitResult);
    }
  }, [
    pageNo,
    filterName,
    filterLocation,
    filterCountry,
    filterZipcode,
    filterCompany,
    filterMyConnect,
  ]);

  return (
    <>
      <div
        className={`page_heading mb-5 d-flex align-items-center ${
          showTitle ? "justify-content-between" : "justify-content-end"
        }`}
      >
        {showTitle && (
          <h1 className="position-relative pb-4 text-uppercase">
            {componentName}
          </h1>
        )}

        <div className="d-flex align-items-center">
          <Link
            to="#"
            className="filter_btn d-flex align-items-center justify-content-center bg_primary me-2"
            onClick={refreshHandler}
          >
            <span className="material-icons-outlined text-white">refresh</span>
          </Link>
          <Link
            to="#"
            className="filter_btn d-flex align-items-center justify-content-center bg_primary"
            data-bs-toggle="offcanvas"
            data-bs-target="#networkFilter"
          >
            <span className="material-icons-outlined text-white">
              filter_list
            </span>
          </Link>
        </div>
      </div>
      <div className="speaker_outer">
        <div className="row">
          {isLoading ? (
            placeholderCount.map((item, index) => {
              return <UserPlaceHolder key={index} />;
            })
          ) : memberList.length > 0 ? (
            memberList.map((memberData, index) => {
              return (
                <UserCard
                  token={token}
                  eventMemberData={memberData}
                  key={index}
                  serverUrl={url.SERVER_URL}
                  onSelectMeeting={onSelectMeeting}
                  onSelectConnect={onSelectConnect}
                  onViewConnect={onViewConnect}
                />
              );
            })
          ) : (
            <div className="no_events text-center">
              <span className="d-block text-center mb-2">
                <img src={assetImages.handShake} alt="" />
              </span>
              <h5 className="text-primary fs-sm ">
                No {componentName} to show
              </h5>
            </div>
          )}
        </div>

        {/* load more */}
        {hideLoadMore ? (
          <div className="load_more mt-5 text-center">
            <Link to="#" className="btn disabled">
              No more {componentName} to display
            </Link>
          </div>
        ) : (
          <div className="load_more mt-5 text-center">
            <Link
              to="#"
              className="btn primary-btn"
              onClick={() => {
                onNextPage();
              }}
            >
              load more
            </Link>
          </div>
        )}

        <InitialMeetingModal
          personName={personName}
          setPersonId={setPersonId}
          setPersonName={setPersonName}
          setcomments={setcomments}
          setmeetingReason={setmeetingReason}
        />

        <SetupMeetingModal
          token={token}
          personId={personId}
          personName={personName}
          setPersonId={setPersonId}
          setPersonName={setPersonName}
          setSelectedMeetingDate={setSelectedMeetingDate}
          setSelectedTimeSlot={setSelectedTimeSlot}
          selectedTimeSlot={selectedTimeSlot}
          setcomments={setcomments}
          setmeetingReason={setmeetingReason}
        />

        <MeetingDetailsModal
          token={token}
          personId={personId}
          personName={personName}
          setPersonId={setPersonId}
          setPersonName={setPersonName}
          setSelectedMeetingDate={setSelectedMeetingDate}
          selectedMeetingDate={selectedMeetingDate}
          setSelectedTimeSlot={setSelectedTimeSlot}
          selectedTimeSlot={selectedTimeSlot}
          meetingReason={meetingReason}
          comments={comments}
        />

        <ScheduleConfirmModal
          personName={personName}
          selectedTimeSlot={selectedTimeSlot}
          selectedMeetingDate={selectedMeetingDate}
          onModalClose={resetScheduleMeet}
        />

        {/* <div className="request_modal">
          <div className="modal fade" id="meeting_request">
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-body p-5">
                  <div className="request_alert_icon d-flex align-items-center justify-content-center">
                    <img src="images/alert.svg" alt="" />
                  </div>
                  <div className="request_info text-center">
                    <h3 className="text-primary fs-lg text-uppercase mb-4">
                      Requested for Meeting
                    </h3>
                    <div className="request_btns d-flex gap-2">
                      <a href="javascript:void(0);" className="btn w-50">
                        Open Meetings
                      </a>
                      <a
                        href="javascript:void(0);"
                        data-bs-dismiss="modal"
                        className="btn primary-btn w-50"
                      >
                        Close For NoW
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}

        <ConnetModal
          token={token}
          personId={personId}
          personName={personName}
          setPersonId={setPersonId}
          setPersonName={setPersonName}
          afterModalClose={getEventMembers}
        />

        <ViewConnectModal
          token={token}
          personId={personId}
          setPersonId={setPersonId}
        />

        <UserListFilterPopup
          setfilterName={setfilterName}
          setfilterLocation={setfilterLocation}
          setfilterCountry={setfilterCountry}
          setfilterMyConnect={setfilterMyConnect}
          setfilterZipcode={setfilterZipcode}
          setfilterCompany={setfilterCompany}
        />
      </div>
    </>
  );
};

export default UserList;
